/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/appCardList.config.json';
import axios from 'axios';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { VApplication } from '../../../../application';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export interface IGetSupplierOrgProps {
  offset?: number;
  size?: number;
  criteria?: any;
  userGroupOffset?: number;
  userGroupSize?: number;
  userGroupCriteria?: any;
}

export interface ISupplierOrgMethods extends IPluginMethodMap {
  getSupplierOrgProps(args: any): Promise<any>;
}

export class SupplierOrgService implements IAgentPlugin {
  readonly methods: ISupplierOrgMethods;

  constructor() {
    this.methods = {
      getSupplierOrgProps: this.getSupplierOrgProps.bind(this),
    };
  }

  async getSupplierOrgProps(args: any) {
    console.log(`userGroup payload:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: USER_GROUP_LIST,
    //       variables: {
    //         input: {
    //           offset: args?.userGroupOffset ?? args?.offset,
    //           size: args?.userGroupSize ?? args?.size,
    //           criteria: {
    //             parent: null,
    //             ...args?.userGroupCriteria
    //           },
    //         },
    //       },
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data?.getListOfUserGroup) {
    //       let _templateData = this.formatHolderGroup(
    //         config
    //       );
    //       return {
    //         userGroups:{
    //           appCardList: _templateData,
    //           isEmpty: res?.data?.getListOfUserGroup?.data?.length <= 0,
    //           activePage: res?.data?.getListOfUserGroup?.currentPage,
    //           pageSize: res?.data?.getListOfUserGroup?.pageSize,
    //           totalCount: res?.data?.getListOfUserGroup?.totalCount,
    //           totalPages: res?.data?.getListOfUserGroup?.totalPages,
    //         }
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   throw err;
    // }
    return {
      userGroups: {
        ...config,
      },
    };
  }

  private formatHolderGroup(data: any) {
    console.log('formatHolderGroup =>', data);
    let _appCard = data.map((item: any) => {
      return {
        appCardId: item?._id,
        appCardImage: item?.logo,
        appCardTitle: item?.name,
        appCardDescription: item?.description,
      };
    });

    return _appCard;
  }
}
